/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UsageType = {
    Everyone: 'EVERYONE',
    CarriedFreelancer: 'CARRIED_FREELANCER',
    UmbrellaCompany: 'UMBRELLA_COMPANY'
} as const;
export type UsageType = typeof UsageType[keyof typeof UsageType];


export function instanceOfUsageType(value: any): boolean {
    for (const key in UsageType) {
        if (Object.prototype.hasOwnProperty.call(UsageType, key)) {
            // @ts-ignore
            if (UsageType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UsageTypeFromJSON(json: any): UsageType {
    return UsageTypeFromJSONTyped(json, false);
}

export function UsageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsageType {
    return json as UsageType;
}

export function UsageTypeToJSON(value?: UsageType | null): any {
    return value as any;
}

